import React from "react";
import { Bell, ChevronRight } from "lucide-react";
import { formatBRL, formatDate, dueState, FREQ_LABEL } from "./LoanDetailsDialog";

export default function LoanRow({ loan: l, customerName, today, onClick, showCustomer = true, border = false, compact = false }) {
  const remaining = Math.max(0, l.total_receivable - l.total_paid);
  const due = dueState(l, today);
  return (
    <button
      data-testid={`loan-row-${l.id}`}
      onClick={onClick}
      className={`flex w-full items-center gap-3 text-left hover:bg-white/[0.03] ${compact ? "px-3 py-2.5" : "px-4 py-3"} ${
        border ? "border-t border-white/5" : ""
      }`}
      style={{ transition: "background-color 0.15s ease" }}
    >
      <div
        className={`h-9 w-1 shrink-0 rounded-full ${
          due === "late" ? "bg-red-500" : due === "today" ? "bg-[#D4FF00]" : l.status === "paid" ? "bg-green-500/60" : "bg-white/10"
        }`}
      />
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <span className="truncate font-display text-sm font-bold text-white">
            {showCustomer ? customerName || "Cliente removido" : `${FREQ_LABEL[l.frequency] || l.frequency} · ${formatBRL(l.principal)} emprestado`}
          </span>
          {l.status === "paid" && (
            <span className="rounded-sm bg-green-500/20 px-1.5 py-0.5 text-[0.62rem] font-bold uppercase tracking-wider text-green-400">Quitado</span>
          )}
          {due && (
            <span
              data-testid={`loan-due-badge-${l.id}`}
              className={`inline-flex shrink-0 items-center gap-1 rounded-sm px-1.5 py-0.5 text-[0.62rem] font-bold uppercase tracking-wider ${
                due === "late" ? "bg-red-500/20 text-red-300" : "bg-[#D4FF00]/20 text-[#D4FF00]"
              }`}
            >
              <Bell className="h-2.5 w-2.5" />
              {due === "late" ? "Atrasado" : "Vence hoje"}
            </span>
          )}
        </div>
        <div className="mt-0.5 text-[0.75rem] text-zinc-500">
          {showCustomer && <>{FREQ_LABEL[l.frequency] || l.frequency} · </>}
          Início {formatDate(l.start_date)} · {l.installments_paid}/{l.num_installments} parcelas
          {l.source && <span className="text-[#22C55E]"> · {l.source}</span>}
          {l.next_due_date && ` · Próx. ${formatDate(l.next_due_date)}`}
          {l.rollovers > 0 && <span className="text-[#A78BFA]"> · {l.rollovers}× só juros</span>}
        </div>
      </div>
      <div className="shrink-0 text-right">
        <div className="font-mono-num text-sm font-bold text-[#D4FF00]">{formatBRL(l.total_receivable)}</div>
        <div className="text-[0.7rem] text-zinc-500">
          Restante{" "}
          <span className="font-mono-num font-semibold" style={{ color: remaining > 0 ? "#F59E0B" : "#00FF66" }}>
            {formatBRL(remaining)}
          </span>
        </div>
      </div>
      <ChevronRight className="h-4 w-4 shrink-0 text-zinc-600" />
    </button>
  );
}
